import React, { Component } from 'react';
import {resolveVariables} from 'functions';
import {NumberInput, CSSInput, TextInput} from 'library';

class Stars extends React.Component {
    static component_name = 'Stars';
    constructor(props) {
        super(props);
        this.config = {
            form_components: [
                <TextInput label={'filled'} name={'filled'} />,
                <TextInput label={'size'} name={'size'} />,
                <CSSInput label={'style'} name={'style'} default={{}} />,
            ],
            can_have_children: false,
        }
    }

    render() {
        var size = 'fa-1x';
        if (this.props.size) {
            size = 'fa-' + this.props.size + 'x';
        }

       var icon = 'fa-star';
       var filled = 0;
       if (this.props.filled) {
           try {
               filled = parseInt(this.props.filled);
           }
           catch (e) {
               console.log(e);
           }
       }

       var stars = [];
       for (var i = 0; i < 5; i++) {
         if (i < filled) {
           stars.push(<i style={{'color':'#ffc120'}} className={"fas " + size + " " + icon}></i>)
         }
         else {
           stars.push(<i style={{'color':'#ccc'}} className={"fas " + size + " " + icon}></i>)
         }
       }


        return (
            <div style={{'display':'inline-block'}}>
              {stars}
            </div>
        );
    }
}

export default Stars;
